import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  API_ACTIVE_PARTNERS,
  API_PAYMENT_TYPES,
  API_UPDATE_PAYMENT_ITEM,
} from "../../utils/apis";
import {
  createDeleteAction,
  createEditAction,
  createViewAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_PAYMENT_ITEMS } from "../../utils/urls";
import useGet from "../common/useGet";

const url = URL_PAYMENT_ITEMS;

export const usePaymentItems = () => {
  const tableColumns = () => [
    { id: "partner", header: "Partner Name", filter: {} },
    { id: "item_name", header: "Payment Item Name", filter: {} },
    { id: "paycode", header: "Paycode", filter: {} },
    { id: "payment_type", header: "Payment Type", filter: {} },
    { id: "minimum_item_amount", header: "Minimum Item Amount", filter: {} },
    { id: "uses_pin", header: "Uses Pin", filter: {} },
    { id: "has_impact", header: "Has Impact", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        partner: item?.active_partner?.partner_name,
        uses_pin: <BooleanTags status={item?.uses_pin} />,
        has_impact: <BooleanTags status={item?.has_impact} />,
        actions: (
          <FormActions
            actions={[
              createEditAction(url, item?.paycode),
              createDeleteAction(
                `transact/payment-item/${item?.paycode}/`,
                `${item?.item_name}`,
              ),
              createViewAction(url, item?.paycode),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Payment Item Details",
          fields: {
            "Payment Item Name": item?.item_name,
            paycode: item?.paycode,
            "Payment Type": item?.payment_type,
            "Partner Name": item?.active_partner?.partner_name || "N/A",
            "Partner Code": item?.active_partner?.partner_code || "N/A",
            "Minimum Amount": item?.minimum_item_amount,
            "Is Active": item?.is_active ? "Yes" : "No",
            has_impact: <BooleanTags status={item?.has_impact} />,
            uses_pin: <BooleanTags status={item?.uses_pin} />,
            "Uses Narration": item?.uses_narration ? "Yes" : "No",
            "Impacts Agent": item?.impacts_agent ? "Yes" : "No",
            "Default Success": item?.default_success ? "Yes" : "No",
            "Hide Customer ID": item?.hide_customerid ? "Yes" : "No",
            "Requires Bank": item?.requires_bank ? "Yes" : "No",
            "Callback URL": item?.active_partner?.callback_url || "N/A",
            "Is Offline": item?.active_partner?.is_offline ? "Yes" : "No",
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return { tableData, tableColumns, formRoute, viewData };
};

// FORM
export const usePaymentItemsForm = ({ form }) => {
  const { loadData, loading, data: paymentTypeData } = useGet();
  const {
    loadData: loadActivePartnersData,
    data: activePartnersData,
    loading: activePartnersLoading,
  } = useGet();

  useEffect(() => {
    loadData({
      api: `${API_PAYMENT_TYPES}`,
    });
  }, []);
  useEffect(() => {
    loadActivePartnersData({
      api: `${API_ACTIVE_PARTNERS}`,
    });
  }, []);

  const sections: any = [
    {
      title: "Payment Item Details",
      fields: [
        {
          field_name: "partner",
          label: "Partner Name",
          type: "select",
          options_data: activePartnersData?.partners?.map((item: any) => ({
            id: item.id,
            name: item.partner_name,
          })),
        },
        {
          field_name: "item_name",
          label: "Payment Item Name",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "paycode",
          label: "Paycode",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "payment_type",
          type: "select",
          label: "Payment Type",
          props: { required: true },
          loading: loading,
          options_data: paymentTypeData?.results?.map((item) => ({
            id: item.name,
            name: item.name,
          })),
        },
        {
          field_name: "uses_pin",
          type: "select",
          label: "Use Pin",
          value: form?.uses_pin,
          props: { required: true },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "has_impact",
          type: "select",
          label: "Has Impact",
          value: form?.has_impact,
          props: { required: true },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "minimum_item_amount",
          label: "Minimum item amount",
          type: "number",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(url);
  // const retrieveRoute = `transact/payment-item/${id}/retrieve/`;

  return { sections, redirect, activePartnersLoading };
};

// SUBMIT
export function submitPaymentItems(payload: any, id: string | number) {
  return {
    api: id ? `${API_UPDATE_PAYMENT_ITEM}${id}/` : API_UPDATE_PAYMENT_ITEM,
    params: {
      ...payload,
    },
    method: id ? "PATCH" : "POST",
  };
}
